import Vue from 'vue';
import Vuex from 'vuex';
import {analyticsMiddleware} from 'vue-analytics';
import auth from './modules/auth';
import nav from './modules/nav';
import booking from './modules/booking';
import stats from './modules/stats';
import allocation from './modules/allocation';
import admin from './modules/admin';
import info from './modules/info'
import alert from './modules/alert'
import dashboard from './modules/dashboard';
import account from './modules/account';
import introduction from './modules/introduction';
import contract from './modules/contract';
import instruction from './modules/instruction'

Vue.config.productionTip = false;
Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        auth,
        nav,
        booking,
        stats,
        allocation,
        admin,
        info,
        alert,
        dashboard,
        account,
        introduction,
        contract,
        instruction
    },
    plugins: [
        analyticsMiddleware
    ]
});



// WEBPACK FOOTER //
// ./src/store/index.js